import * as React from 'react';
import type { UploadRestrictedProductsFilePayload } from 'contracts/restricted-products/restricted-products';
import { api, handleApiError } from 'services';

export const useUploadRestrictedProductFiles = () => {
  const uploadBlockedProductsFile = React.useCallback(async (payload: UploadRestrictedProductsFilePayload) => {
    const formData = new FormData();
    formData.append('file', payload.file, payload.file.name);
    try {
      await api.post('/restricted-materials/blocked-products', formData);
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  return {
    uploadBlockedProductsFile,
  };
};